import React from 'react';
import BaseGridToolbar, { FilterConfig } from '../../base-ui/Grid/components/BaseGridToolbar';

interface AssemblyGridToolbarProps {
    filter: string;
    setFilter: React.Dispatch<React.SetStateAction<string>>;
    assemblyType: string;
    setAssemblyType: React.Dispatch<React.SetStateAction<string>>;
    edgeType: string;
    setEdgeType: React.Dispatch<React.SetStateAction<string>>;
    allData: any[];
    handleRefresh?: () => void;
    onAdd?: () => void;
}

const AssemblyGridToolbar: React.FC<AssemblyGridToolbarProps> = ({
    filter,
    setFilter,
    assemblyType,
    setAssemblyType,
    edgeType,
    setEdgeType,
    allData,
    handleRefresh,
    onAdd
}) => {
    // Filter configurations specific to assemblies
    const filterConfigs: FilterConfig[] = [
        {
            field: 'assemblyType',
            label: 'Assembly Type',
            extractUnique: (data) => data.map(row => row.assemblyType?.name).filter(Boolean)
        },
        {
            field: 'edgeType', 
            label: 'Edge Type',
            extractUnique: (data) => data.map(row => row.edgeType?.name).filter(Boolean)
        }
    ];

    // Convert individual state to filters object
    const filters = { assemblyType, edgeType };
    const setFilters = (newFilters: Record<string, string>) => {
        setAssemblyType(newFilters.assemblyType || '');
        setEdgeType(newFilters.edgeType || '');
    };

    return (
        <BaseGridToolbar
            filter={filter}
            setFilter={setFilter}
            filters={filters}
            setFilters={setFilters}
            filterConfigs={filterConfigs}
            allData={allData}
            handleRefresh={handleRefresh}
            onAdd={onAdd}
            addButtonLabel="Add Assembly"
        />
    );
};

export default AssemblyGridToolbar;